import { useMemo } from 'react'
import { computeFreshness, ageMs } from '@/lib/dates'
import type { FreshnessState } from '@/types/status'

export interface StaleState {
  freshness: FreshnessState
  ageMs: number
}

/**
 * Compute freshness state for an `updatedAt` timestamp.
 * Updates whenever `updatedAt` changes.
 */
export function useStaleState(
  updatedAt: string | null | undefined,
  refreshInterval?: number
): StaleState {
  return useMemo(() => {
    if (!updatedAt) {
      return { freshness: 'critical', ageMs: Infinity }
    }
    return {
      freshness: computeFreshness(updatedAt, refreshInterval),
      ageMs: ageMs(updatedAt),
    }
  }, [updatedAt, refreshInterval])
}
